<template>
  <footer class="jw-footer">
    <div class="flex">
      <div class="flex-item">
        <img src="@/assets/img/logo-off.png" height="30" alt="">
      </div>
      <div class="wechat">
        <img @click="jumpLink('wechat')" src="@/assets/img/wechat.png" width="30" alt="">
        <img @click="jumpLink('in')" src="@/assets/img/in.png" class="margin-left-15" width="30" alt="">
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  components: {},
  data () {
    return {

    }
  },
  methods: {
    jumpLink (type) {
      if (type === 'in') {
        window.open('https://www.linkedin.com/company/3519789/')
      } else {
        window.open('https://mp.weixin.qq.com/s/kfaiJ3F_hUTJYKmKurIbvA')
      }
    }
  }
}
</script>

<style scoped>
  .jw-footer {
    height: 50px;
    padding: 0 10px;
    line-height: 50px;
    background: #4D4A4A;
    color: #BDBEBB;
  }
</style>
